var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmeetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6514 20.0005L32.3301 25.3485L38.6215 29.3691L39.7185 20.0334L38.6215 10.9062L32.2094 14.4386L27.6514 20.0005Z",
    fill: "#00832D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 28.502V36.4554C0.5 38.2737 1.97275 39.7464 3.79105 39.7464H11.7444L13.39 33.7347L11.7444 28.502L6.28677 26.8564L0.5 28.502Z",
    fill: "#0066DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7444 0.253906L0.5 11.4983L6.28677 13.1439L11.7444 11.4983L13.3625 6.33687L11.7444 0.253906Z",
    fill: "#E94235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7444 11.498H0.5V28.5018H11.7444V11.498Z",
    fill: "#2684FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8065 5.01495L38.6211 10.9059V29.3687L45.8395 35.2871C46.92 36.1319 48.4997 35.3612 48.4997 33.9872V6.28749C48.4997 4.89702 46.8844 4.13459 45.8065 5.01495ZM27.6509 20.0002V28.5021H11.7441V39.7465H35.33C37.1483 39.7465 38.6211 38.2738 38.6211 36.4555V29.3687L27.6509 20.0002Z",
    fill: "#00AC47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.33 0.253906H11.7441V11.4983H27.6509V20.0002L38.6211 10.9114V3.54496C38.6211 1.72665 37.1483 0.253906 35.33 0.253906Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeetLogo);
export default __webpack_public_path__ + "static/media/gmeetLogo.2ebd5b1186c4b3bc2cda0722fa5856d6.svg";
export { ForwardRef as ReactComponent };